module.exports = __webpack_public_path__ + "static/media/welcome-cover.4dd360ab.webp";